import { render, staticRenderFns } from "./templateDialog.vue?vue&type=template&id=f37ce906&scoped=true"
import script from "./templateDialog.vue?vue&type=script&lang=js"
export * from "./templateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37ce906",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\pj\\Platform\\xrcNet\\xrcNet_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f37ce906')) {
      api.createRecord('f37ce906', component.options)
    } else {
      api.reload('f37ce906', component.options)
    }
    module.hot.accept("./templateDialog.vue?vue&type=template&id=f37ce906&scoped=true", function () {
      api.rerender('f37ce906', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/area/areamenu/templateDialog.vue"
export default component.exports